//App

import { SettingDto } from "../app/model/api/types/dto/settingDto";

export class SettingViewModel {
  id?: string | null;
  name: string | null;
  description: string | null;
  code: string | null;
  enumName: string | null;
  value: string | null;
  sortValue: number | null;
  isActive: boolean | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    sortValue: number | null,
    isActive: boolean | null,
    code: string | null,
    enumName: string | null,
    value: string | null,
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.sortValue = sortValue;
    this.isActive = isActive;
    this.code = code;
    this.enumName = enumName;
    this.value = value;
  }

  toDto(): SettingDto {
    return {
      id: this.id,
      isActive: this.isActive,
      code: this.code,
      enumName: this.enumName,
      value: this.value,
      name: this.name,
      description: this.description,
      sortValue: this.sortValue,
    };
  }

  mapFromDto(dto: SettingDto): void {
    this.id = dto.id;
    this.isActive = dto.isActive || true;
    this.name = dto.name;
    this.description = dto.description;
    this.sortValue = dto.sortValue;
    this.code = dto.code;
    this.enumName = dto.enumName;
    this.value = dto.value;
  }
}
